export const firebaseConfig = {
  apiKey: "AIzaSyDtvAiRbuxY-0vKH63S2IpOmcbym2Nyrlc",
  authDomain: "strapy-72c4a.firebaseapp.com",
  projectId: "strapy-72c4a",
  storageBucket: "strapy-72c4a.appspot.com",
  messagingSenderId: "834957777308",
  appId: "1:834957777308:web:65a1595c7241a197ac5059",
};
